import cn from 'classnames';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import { getAnalyticsObject, sendWriteReviewEvent } from 'src/helpers/analyticsEvents';
import { useProductsTags } from 'src/store/hooks/filters';
import { useOrganizationDetails } from 'src/store/hooks/organizations';
import { TReviewListQuery } from 'src/types/router';

import { Space } from '@sravni/react-design-system';
import { ReviewsActionBlock } from '@sravni/react-ugc/lib/ReviewsActionBlock';
import { useIsMobile } from '@sravni/react-utils';
import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import styles from './side-block.module.scss';

export type TSideBlockProps = {
  hasButton?: boolean;
  organizationType: PAGE_TYPE;
  organization: string;
};

export const SideBlock: React.FC<TSideBlockProps> = ({ hasButton, organizationType, organization }) => {
  const router = useRouter() as TRouter<TReviewListQuery>;
  const {
    query: { reviewObjectId },
  } = router;

  const isMobile = useIsMobile();

  const { name, id } = useOrganizationDetails(organization);
  const products = useProductsTags();

  const gaObj = getAnalyticsObject(name, organizationType, products, 'Боковой блок');
  const sendEvent = useCallback(() => sendWriteReviewEvent(gaObj), [gaObj]);

  const isVisibleMobile = hasButton && isMobile;

  return (
    <Space justify={'stretch'} className={cn({ [styles.fixedButtonWrapper]: isVisibleMobile })}>
      <div className={cn({ [styles.buttonWrapper]: isVisibleMobile })}>
        <ReviewsActionBlock
          handleClickActionButton={sendEvent}
          organizationType={organizationType}
          isOnlyMobileButton={isVisibleMobile}
          organizationId={id || reviewObjectId}
        />
      </div>
    </Space>
  );
};
